if (!customElements.get("product-offers")) {
	customElements.define(
		"product-offers",
		class ProductOffers extends HTMLElement {
			constructor() {
				super();
			}

			connectedCallback() {
				this.inputs = this.querySelectorAll(".product-offers__item input");
				this.inputs.forEach((input) =>
					input.addEventListener("change", () => {
						document.querySelector(".product-form__button--price").textContent =
							input.dataset.finalPrice;
					})
				);
			}
		}
	);
}
